import React, {useState} from "react"
import {IconChevronDown, IconChevronRight, IconList} from "@tabler/icons-react"
import {FilterCondition} from "../filterTypes"
import {FilterConditionDisplay} from "./FilterConditionDisplay"

// Collapsible Conditions Section
export const ConditionsSection = ({
  conditions,
}: {
  conditions: FilterCondition[]
}) => {
  const [isExpanded, setIsExpanded] = useState(false) // Default to collapsed

  if (!conditions || conditions.length === 0) {
    return null // Don't render if no conditions
  }

  return (
    <div className="mt-4">
      <div
        className="flex cursor-pointer items-center justify-between rounded-t-md bg-gray-50 px-3 py-2 hover:bg-gray-100"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-center gap-2">
          {isExpanded ? (
            <IconChevronDown className="h-4 w-4 text-gray-500" />
          ) : (
            <IconChevronRight className="h-4 w-4 text-gray-500" />
          )}
          {/* <IconList className="h-4 w-4 text-blue-500" /> */}
          <h4 className="font-medium text-gray-800">
            Filter Conditions ({conditions.length})
          </h4>
        </div>
      </div>

      {isExpanded && (
        <div className="rounded-b-md border border-t-0 border-gray-200 bg-white p-3 shadow-sm">
          {conditions.map((condition, index) => (
            <FilterConditionDisplay key={index} condition={condition} />
          ))}
        </div>
      )}
    </div>
  )
}
